import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
// import store from './store';
import { notifStore } from "@/store/notif";
import { analytics } from './client/firebase';
import vuetify from './plugins/vuetify'
// import "leaflet/dist/leaflet.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";
import moment from 'moment-timezone'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import VueMask from '@devindex/vue-mask';
import PermissionMixin from '@/mixins/PermissionMixin';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
//import 'vue-toast-notification/dist/theme-bootstrap.css';                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
//import keycloakService from './services/keycloak';

// Suppress ResizeObserver loop error (benign warning from Vuetify/browser)
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver loop')) {
    return;
  }
  resizeObserverErr(...args);
};

const app = createApp(App)
  .use(router)
  // .use(store)  
  .use(moment)
  .use(VueMask)
  .use(notifStore)
  .use(VueDatePicker);

app.use(VueSweetalert2);
app.config.globalProperties.$analytics = analytics;
app.use(ToastPlugin);
app.mixin(PermissionMixin);
//app.use(keycloakService);
app.use(vuetify).mount('#app');
app.component('VueDatePicker', VueDatePicker);